import { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/header/header";
import Footer from "./components/footer/footer";

import Home from "./pages/home/home";
import Disclaimer from "./pages/disclaimer/disclaimer";
import Discord from "./pages/discord/discord";
import Submit from "./pages/submit/submit";
import Tales from "./pages/tales/tales";
import Timer from "./pages/timer/timer";

import Bomber from "./pages/builds/pvp/magic-necromancer/bomber";
import Corrosive from "./pages/builds/pvp/magic-dragonknight/corrosive";
import Executioner from "./pages/builds/pvp/magic-sorcerer/executioner";
import Healer from "./pages/builds/pvp/magic-warden/heal-mother";

class App extends Component {
    render() {
        return (
            <div className="App-div">
                <Header />
                <Routes>
                    <Route path="/" element={<Navigate to="/home" state={{ todos: [] }} replace />} />
                    <Route path="*" element={<Navigate to="/home" state={{ todos: [] }} replace />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                    <Route path="/discord" element={<Discord />} />
                    <Route path="/submit" element={<Submit />} />
                    <Route path="/tales" element={<Tales />} />
                    <Route path="/timer" element={<Timer />} />
                    <Route path="/pvp-magic-necromancer-bomber" element={<Bomber />} />
                    <Route path="/pvp-magic-dragonknight-corrosive" element={<Corrosive />} />
                    <Route path="/pvp-magic-sorcerer-executioner" element={<Executioner />} />
                    <Route path="/pvp-magic-warden-heal-mother" element={<Healer />} />
                </Routes>
                <Footer />
            </div>
        );
    }
}

export default App;